function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * @license
 * Copyright (c) 2015 - 2023 Vaadin Ltd.
 * This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
 */
import { PositionMixin } from '@vaadin/overlay/src/vaadin-overlay-position-mixin.js';
/**
 * @polymerMixin
 * @mixes PositionMixin
 */

export var ComboBoxOverlayMixin = function ComboBoxOverlayMixin(superClass) {
  return /*#__PURE__*/function (_PositionMixin) {
    _inherits(ComboBoxOverlayMixin, _PositionMixin);

    var _super = _createSuper(ComboBoxOverlayMixin);

    function ComboBoxOverlayMixin() {
      var _this;

      _classCallCheck(this, ComboBoxOverlayMixin);

      _this = _super.call(this);
      _this.requiredVerticalSpace = 200;
      return _this;
    }
    /** @protected */


    _createClass(ComboBoxOverlayMixin, [{
      key: "connectedCallback",
      value: function connectedCallback() {
        _get(_getPrototypeOf(ComboBoxOverlayMixin.prototype), "connectedCallback", this).call(this);

        var comboBox = this._comboBox;
        var hostDir = comboBox && comboBox.getAttribute('dir');

        if (hostDir) {
          this.setAttribute('dir', hostDir);
        }
      }
      /**
       * Override method inherited from `Overlay`
       * to not close on position target click.
       *
       * @param {Event} event
       * @return {boolean}
       * @protected
       */

    }, {
      key: "_shouldCloseOnOutsideClick",
      value: function _shouldCloseOnOutsideClick(event) {
        var eventPath = event.composedPath();
        return !eventPath.includes(this.positionTarget) && !eventPath.includes(this);
      }
      /** @protected */

    }, {
      key: "_updateOverlayWidth",
      value: function _updateOverlayWidth() {
        var propPrefix = this.localName;
        this.style.setProperty("--_".concat(propPrefix, "-default-width"), "".concat(this.positionTarget.clientWidth, "px"));
        var customWidth = getComputedStyle(this._comboBox).getPropertyValue("--".concat(propPrefix, "-width"));

        if (customWidth === '') {
          this.style.removeProperty("--".concat(propPrefix, "-width"));
        } else {
          this.style.setProperty("--".concat(propPrefix, "-width"), customWidth);
        }
      }
      /** @private */

    }, {
      key: "_setOverlayWidth",
      value: function _setOverlayWidth(positionTarget, opened) {
        if (positionTarget && opened) {
          this._updateOverlayWidth();

          this._updatePosition();
        }
      }
    }], [{
      key: "observers",
      get: function get() {
        return ['_setOverlayWidth(positionTarget, opened)'];
      }
    }]);

    return ComboBoxOverlayMixin;
  }(PositionMixin(superClass));
};